import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IAppointment } from '../../models/appointment.interface';
import { Gender } from "../../models/common.interface";
import { CVA_AUTH_MODULES } from '../../models/auth.modules.enum';
import { CVA_CONSTANTS } from '../../util/constants';
import { ROUTE_CONSTANTS } from '../../util/route.constants';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
    standalone: false,
    selector: 'cva-patient-banner',
    templateUrl: './patient-banner.component.html',
    styleUrls: ['./patient-banner.component.scss'],
    
})
export class PatientBannerComponent implements OnChanges {
  @Input() appointment!: IAppointment;  
  genderAbbr!:string;
  isLIC = localStorage.getItem('isLIC') === "true";
  CVA_AUTH_MODULES = CVA_AUTH_MODULES;
  CVA_CONSTANTS = CVA_CONSTANTS;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  @Output() callGotoBrowser = new EventEmitter<any>()
  cvaUI_url = environment.cvaUI_url;

  constructor(private readonly  router: Router){}
  
  ngOnChanges(changes: SimpleChanges): void {    
    if(changes['appointment']?.currentValue){
      const gender:string=changes['appointment'].currentValue.patient.gender;     
      const genderAbbr= Gender[gender.toLowerCase() as keyof typeof Gender];
      this.genderAbbr= genderAbbr|| '';
    }
  }

  gotoBrowser() {
    this.callGotoBrowser.emit();
  }

  reDirectToSetting() {
    this.router.navigate([ROUTE_CONSTANTS.SOAP_CONFIGURATION]);
  }
}
